export default __webpack_public_path__ + "static/media/Leogrande_036.df8caa05.jpg";